import { render, staticRenderFns } from "./tabela-cancelamento.vue?vue&type=template&id=3dc7dcde&"
import script from "./tabela-cancelamento.vue?vue&type=script&lang=js&"
export * from "./tabela-cancelamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports